const codes = {
  // 特殊系
  'string.uketsuke_id': ['app-uketsuke-id'],
  'string.hinban_code': ['app-code', {'clearable': false, 'class': 'app-code08', 'maxLength': 7, 'upperCase': true}],
  'string.edaban_code': ['app-code', {'clearable': false, 'class': 'app-code08', 'maxLength': 7, 'upperCase': true}]
}
export default codes



// WEBPACK FOOTER //
// ./src/app/parts/type_mapping_codes.js